import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { UntypedFormControl } from '@angular/forms';
import {
    BaseNestedFieldDefinition,
    ExtendedBaseProfileField,
    ExtendedProfileField,
    FieldReadHelper,
    FieldType,
    ShComplexInputFieldComponent
} from '@stylehaven/components';

@Component({
    selector: 'med-complex-list-field',
    templateUrl: './complex-list-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComplexListInputFieldComponent extends ShComplexInputFieldComponent {
    public childDefinition$: Observable<BaseNestedFieldDefinition>;
    public childProfileField$: Observable<ExtendedProfileField<BaseNestedFieldDefinition>>;

    public FieldType: typeof FieldType = FieldType;

    constructor(protected fieldHelper: FieldReadHelper) {
        super(fieldHelper);
        this.initChildDefinitionStream();
    }

    protected override initFormValueChangeListener(
        profileField: ExtendedBaseProfileField,
        control: UntypedFormControl
    ): void {
        // Don't do anything since we're simply passing stuff in this component
    }

    private initChildDefinitionStream(): void {
        this.childDefinition$ = this.childDefinitions$.pipe(
            map(children => {
                if (children.length !== 1) {
                    throw new Error(`ComplexListField should have exactly 1 child, but has ${children.length}`);
                }
                return children[0];
            })
        );

        this.childProfileField$ = this.childProfileFields$.pipe(map(profileFields => profileFields[0]));
    }
}
